// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3LsT3","tab":"ProcedureTabs_tab__2tQYa"};